import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import useHovered from 'UIComponents/hooks/useHovered';
import { CloseButton } from './CloseButton';
import { Flex } from 'foundations-components/components/Flex';
import { DragHandle } from 'foundations-components/transitional/components/DragHandle';
import { ViewActionButton } from './ViewActionButton';
import { Box } from 'foundations-components/transitional/components/Box';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { BreezeSingleStarIcon } from 'foundations-assets';
import I18n from 'I18n';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TabContents = ({
  icon,
  scrollToRef,
  children,
  closeDisabled,
  closeTooltip,
  onCloseClickFunction,
  active,
  isDragDisabled,
  tabId,
  isAiGenerated = false,
  onRegenerateViewFunction = () => {},
  onDeleteViewFunction = () => {},
  currentlyEditingAiView
}) => {
  const _useHovered = useHovered({}),
    hoveredProps = Object.assign({}, (_objectDestructuringEmpty(_useHovered), _useHovered));
  const doShowDragHandle = hoveredProps.hovered && !isDragDisabled;
  const doShowCloseButton = (active || hoveredProps.hovered) && !closeDisabled;
  const doShowDeleteButton = (currentlyEditingAiView === null || currentlyEditingAiView === void 0 ? void 0 : currentlyEditingAiView.id) === tabId && active;
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    paddingBlockStart: "200",
    paddingInlineStart: "400",
    paddingInlineEnd: "200"
  }, hoveredProps, {
    children: [doShowDragHandle && /*#__PURE__*/_jsx(Flex, {
      marginInlineStart: "-200",
      marginInlineEnd: "100",
      children: /*#__PURE__*/_jsx(DragHandle, {
        "data-test-id": "tab-contents-drag-handle"
      })
    }), icon, /*#__PURE__*/_jsx("span", {
      ref: scrollToRef,
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        alignItems: "center",
        gap: "100",
        children: [isAiGenerated && /*#__PURE__*/_jsx(BreezeSingleStarIcon, {}), /*#__PURE__*/_jsx(TruncateString, {
          children: children
        })]
      })
    }), isAiGenerated && active && /*#__PURE__*/_jsx(Box, {
      grow: 1,
      children: /*#__PURE__*/_jsx(ButtonWrapper, {
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          children: [/*#__PURE__*/_jsx(ViewActionButton, {
            onClick: () => onRegenerateViewFunction(tabId),
            tabId: tabId,
            tooltip: I18n.text('viewsManagement.modals.generateView.AiActions.regenerate'),
            icon: "regenerate"
          }), !closeDisabled && doShowDeleteButton &&
          /*#__PURE__*/
          //closeDisabled = if there is only one view
          //doShowDeleteButton = if the view is the currently editing ai view and the view is active
          _jsx(ViewActionButton, {
            onClick: () => onDeleteViewFunction(tabId),
            tabId: tabId,
            tooltip: I18n.text('viewsManagement.modals.generateView.AiActions.delete'),
            icon: "delete"
          })]
        })
      })
    }), doShowCloseButton && !doShowDeleteButton && /*#__PURE__*/_jsx(CloseButton, {
      onClick: onCloseClickFunction,
      tabId: tabId,
      tooltip: closeTooltip,
      disabled: closeDisabled
    })]
  }));
};